import React, { useEffect, useRef } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useMount } from 'react-use';

import { compilePath } from '../../../../common/utils/helpers/routes';
import {
  selectActiveItemIndex,
  selectActiveItem,
  selectActiveItemDatasource,
} from '../../../item-details/store';
import { selectSearchParams } from '../../../../common/store/search';
import { selectGeolocation } from '../../../../map/store';
import ItemEdit from '../item-edit/ItemEdit';
import RoadItemEdit from '../road-item-edit/RoadItemEdit';
import {
  clearLastSentEditMetadata,
  longPressLocationChanged,
  setLastSentEditMetadata,
} from '../../../../common/store/item-edit';
import {
  getItemEditSuggestionType,
  getItemType,
} from '../../../../common/utils/helpers/item';
import { ITEM_TYPES } from '../../../../common/utils/constants/constants';

const ItemEditPage = (props) => {
  const item = useSelector(selectActiveItem);
  const datasource = useSelector(selectActiveItemDatasource);
  const searchSelectedFeatureIndex = useSelector(selectActiveItemIndex);
  const searchParams = useSelector(selectSearchParams);
  const geolocation = useSelector(selectGeolocation);
  const history = useHistory();
  const startEditTimestampRef = useRef<number>();

  const dispatch = useDispatch();
  useMount(() => {
    dispatch(clearLastSentEditMetadata());
    dispatch(longPressLocationChanged(null));
  });

  useEffect(() => {
    if (item) {
      startEditTimestampRef.current = Date.now();
    }
  }, [item]);

  if (!item) {
    return (
      <Redirect
        to={{
          pathname: compilePath('results-list'),
          search: history.location.search,
        }}
      />
    );
  }

  if (getItemType(item) === ITEM_TYPES.road) {
    return <RoadItemEdit item={item} />;
  }

  return (
    <>
      <ItemEdit
        {...props}
        item={item}
        datasource={datasource}
        searchSelectedFeatureIndex={searchSelectedFeatureIndex}
        searchQuery={searchParams && searchParams.query}
        userLocation={geolocation}
        onSubmit={(editSuggestionSendingResult) => {
          dispatch(
            setLastSentEditMetadata({
              startEditTimestamp: startEditTimestampRef.current!,
              feedbackType: `edit ${getItemType(item)!.replace('-', ' ')}`,
              editSuggestionId: editSuggestionSendingResult.editSuggestionId,
              featureType: getItemEditSuggestionType(item),
            }),
          );

          // don't push as it should return back to the same step as from item edit
          history.replace({
            pathname: compilePath('thank-you'),
            search: history.location.search,
          });
        }}
        onCancel={() => history.goBack()}
      />
    </>
  );
};

export default ItemEditPage;
